import { render } from "./Accessibility.vue?vue&type=template&id=671f2d39"
import script from "./Accessibility.vue?vue&type=script&lang=js"
export * from "./Accessibility.vue?vue&type=script&lang=js"
script.render = render

export default script